<template>

         <v-card>
         <v-card-title>
            <span class="headline">New Contact Groups</span>
         </v-card-title>
           <v-form ref="form" class="pa-6">
         <v-card-text>
            <v-container>
         
     <v-row>
            <v-col cols="12" lg="6">
                <v-text-field 
               v-model="contactGroupDetail.center"
               disabled
               label="Center" />
            </v-col>
            <v-col cols="12" lg="6">
             <v-select
                     v-model="contactGroupDetail.type"
                     :items="groupType"
                     label="Type"
                     ></v-select>
            </v-col>
        
            <v-col cols="12" lg="6">
              
            </v-col>
            <v-col cols="12" lg="12">
               <v-text-field 
               v-model="contactGroupDetail.name"
               label="Name" />
            </v-col>
       
         <v-col cols="12" lg="12" >
            <v-card height="164" flat>
               <v-textarea
                  v-model="contactGroupDetail.description"
                  outlined
                  label="Group Description"
                  ></v-textarea>
            </v-card>
         </v-col>
         </v-row>
            </v-container>
         </v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
               color="darken-1"
               text
               @click="closeDialog"
            >
               Close
            </v-btn>
            <v-btn
               color="blue darken-1"
               text
               @click="closeDialog"
            >
               Save
            </v-btn>
         </v-card-actions>
         </v-form>

         </v-card>


</template>


<script>
    export default {
       data: () => ({
         fab: false,
      
        contactGroupDetail: {
            center: "Rego Park",
            name: "Test Group",
            type: "Static Members",
            description: "This is a dummy text for description"
         },
         groupType: ["Static Members", "Criteria"],
       }),
      methods: {
         closeDialog () {
            this.$emit('mclosedialog')
         },
      },
     }
</script>

